import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current: null,
  channels: [],
  currentChannel: null,
  replyTo: null,
  replyTo1: null,
  channelMessageList: [],
  refresh: false,
  showThread: false,
  selectedThread: null,
  threadDetails: null,
  refreshThreadMessages: false,
  displayRightPinnedThread: false,
  rightPinnedThreadDetails: null,
  unreadMessageNotifications: [],
  threadUnreadNotifications: [],
  communityNameDetails: [],
  eventReminder: [],
  announcementId: null,
  announcementPopupClick: 0,
};

const community = createSlice({
  name: "community",
  initialState,
  reducers: {
    setCommunityAndChannel: (state, action) => {
      console.log("setting action\n", action);
      let _vc = JSON.parse(localStorage.getItem("visitCommunity") || "{}");
      console.log("_vc", _vc);
      state.current = action.payload.current;
      state.channels = action.payload.channels;
      console.log("Print action.channels value ", action?.payload?.channels);
      localStorage.setItem("lastVisitedCommunity", action.payload.current.id);
      if (action.payload.channel) {
        const _find = action.payload.channels.find(
          (obj) => obj._id == action.payload.channel
        );
        if (_find) state.currentChannel = _find;
        else
          state.currentChannel =
            _vc[action.payload.current.id] || action.payload.channels[0];
      } else {
        console.log("action is \n", action);
        if (action?.payload?.current?.id in _vc) {
          const _find = action.payload.channels.find(
            (obj) => obj._id == _vc[action.payload.current.id]._id
          );
          if (_find) state.currentChannel = _find;
          else state.currentChannel = action.payload.channels[0];
        } else {
          state.currentChannel = action.payload.channels[0];
        }
      }
      state.replyTo = null;
      _vc[action.payload.current.id] = state.currentChannel;
      localStorage.setItem("visitCommunity", JSON.stringify(_vc));
    },
    setCommunityCurrentChannel: (state, action) => {
      console.log("currentChannel currentChannel ######## ===", action, state);
      let _vc = JSON.parse(localStorage.getItem("visitCommunity"));
      _vc[state.current.id] = action.payload;
      state.currentChannel = action.payload;

      state.replyTo = null;
      localStorage.setItem("visitCommunity", JSON.stringify(_vc));
    },
    setChannelMessageList: (state, action) => {
      state.channelMessageList = action.payload;
    },
    setChannelMessageReply: (state, action) => {
      state.replyTo = action.payload;
    },
    setChannelThreadMessageReply: (state, action) => {
      state.replyTo1 = action.payload;
    },
    setMessageRefresh: (state, action) => {
      state.refresh = action.payload;
    },
    setShowThread: (state, action) => {
      state.showThread = action.payload;
    },

    setCreateMessageThreadId: (state, action) => {
      state.createMessageThreadId = action.payload;
    },
    setShowAllThreads: (state, action) => {
      state.showAllThreads = action.payload;
    },

    setSelectedThread: (state, action) => {
      state.selectedThread = action.payload;
    },
    setThreadDetails: (state, action) => {
      state.threadDetails = action.payload;
    },
    setRefreshThreadMessages: (state, action) => {
      state.refreshThreadMessages = action.payload;
    },
    setDisplayRightPinnedThread: (state, action) => {
      state.displayRightPinnedThread = action.payload;
    },
    setRightPinnedThreadDetails: (state, action) => {
      state.rightPinnedThreadDetails = action.payload;
    },
    setUnreadMessageNotifications: (state, action) => {
      state.unreadMessageNotifications = action.payload;
    },
    setThreadUnreadNotifications: (state, action) => {
      state.threadUnreadNotifications = action.payload;
    },
    setCommunityNameDetails: (state, action) => {
      state.communityNameDetails = action.payload;
    },
    setEventReminder: (state, action) => {
      console.log("action", action);
      state.eventReminder = action.payload;
    },
    setAnnouncementId: (state, action) => {
      console.log("Print setAnnouncementId Message Id:", state, action);
      state.announcementId = action.payload;
    },
    setAnnouncementPopupClick: (state, action) => {
      // console.log("Print announcemebnt message click:", state, action);
      state.announcementPopupClick = action.payload;
    },
  },
});

export const {
  setCommunityAndChannel,
  setCommunityCurrentChannel,
  setChannelMessageList,
  setChannelMessageReply,
  setChannelThreadMessageReply,
  setMessageRefresh,
  setShowThread,
  setCreateMessageThreadId,
  setShowAllThreads,
  setSelectedThread,
  setThreadDetails,
  setRefreshThreadMessages,
  setDisplayRightPinnedThread,
  setRightPinnedThreadDetails,
  setUnreadMessageNotifications,
  setThreadUnreadNotifications,
  setCommunityNameDetails,
  setEventReminder,
  setAnnouncementId,
  setAnnouncementPopupClick,
} = community.actions;

export default community.reducer;
